import {EntityService} from './EntityService';

export class AssetService extends EntityService {

  static entity = 'app/asset';

  static getInvoiceSettings(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/tenant-invoice-settings/${id}`).then(res => res.data);
  }

  static getUsingList(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/using-list`, {params}).then(res => res.data);
  }

  static getBannerList(params?: any): Promise<any> {
    return this.axios.get(`${this.entity}/ads`, {params}).then(res => res.data);
  }
}
